import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { DetailFormationComponent } from './detail-formation/detail-formation.component';
import { ListFormationComponent } from './list-formation/list-formation.component';
import { GestionDonneesModule } from '../gestion-donnees/gestion-donnees.module';
import { FormationsModalAjoutFormComponent } from './modal/formations-modal-ajout-form/formations-modal-ajout-form.component';
import { DetailMeetingComponent } from './detail-meeting/detail-meeting.component';
import { MeetingFormComponent } from './modal/meeting-form/meeting-form.component';
import { ListAvailableEmployeesComponent } from './list-available-employees/list-available-employees.component';

@NgModule({
	declarations: [
		ListFormationComponent,
		DetailFormationComponent,
		FormationsModalAjoutFormComponent,
		DetailMeetingComponent,
		MeetingFormComponent
	],
	imports: [
		SharedModule,
		GestionDonneesModule,
		ListAvailableEmployeesComponent
	],
	providers: []
})
export class FormationsModule {}
